<router-outlet></router-outlet>
<app-loader *ngIf="showProgress"></app-loader>
